/**
 * Returns props that make a link safely open in a new tab on desktop while
 * letting mobile OSes deep-link into native apps (YouTube, Spotify, etc.)
 * for matching URLs.
 *
 * Usage:
 *   <a href={url} {...externalLinkProps(url)}>...</a>
 *
 * For internal placeholder hrefs ("#") we just return safe defaults so the
 * page does not jump.
 */
export const externalLinkProps = (href) => {
  if (!href || href === "#") {
    return {
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: (e) => e.preventDefault(),
    };
  }
  return { target: "_blank", rel: "noopener noreferrer" };
};

export const isPresent = (v) => {
  if (v === undefined || v === null) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "object") return Object.keys(v).length > 0;
  return true;
};
